var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_delete")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.17,18.69 L16.83,18.69 L16.83,6.169 L7.17,6.169 L7.17,18.69 Z M19.35,4.17 C19.57,4.17 19.75,4.35 19.75,4.57 L19.75,5.98 C19.75,6.19 19.57,6.37 19.35,6.37 L18.83,6.37 L18.83,20.3 C18.83,20.52 18.66,20.69 18.44,20.69 L5.57,20.69 C5.35,20.69 5.17,20.52 5.17,20.3 L5.17,6.37 L4.65,6.37 C4.43,6.37 4.25,6.19 4.25,5.98 L4.25,4.57 C4.25,4.35 4.43,4.17 4.65,4.17 L8.93,4.17 L8.93,3.69 C8.93,3.48 9.1,3.31 9.31,3.31 L14.69,3.31 C14.9,3.31 15.07,3.48 15.07,3.69 L15.07,4.17 L19.35,4.17 Z M10.6665,8.0388 C10.8665,8.0388 11.0305,8.2188 11.0305,8.4378 L11.0305,16.6388 C11.0305,16.8578 10.8665,17.0388 10.6665,17.0388 L9.3935,17.0388 C9.1935,17.0388 9.0305,16.8578 9.0305,16.6388 L9.0305,8.4378 C9.0305,8.2188 9.1935,8.0388 9.3935,8.0388 L10.6665,8.0388 Z M14.5464,8.0388 C14.7464,8.0388 14.9104,8.2188 14.9104,8.4378 L14.9104,16.6388 C14.9104,16.8578 14.7464,17.0388 14.5464,17.0388 L13.2744,17.0388 C13.0734,17.0388 12.9104,16.8578 12.9104,16.6388 L12.9104,8.4378 C12.9104,8.2188 13.0734,8.0388 13.2744,8.0388 L14.5464,8.0388 Z",
    id: "Shape",
    fill: "#303030"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_delete.96984d5f.svg";
export { ForwardRef as ReactComponent };